import { LocationId } from '@deltasierra/ids';
import { AgencyId } from '../agency/Agency';
import { ClientId } from '../client';
import { assertNever } from '../common';
import { PlatformId } from '../platform/Platform';
import { IntegrationId } from './Integration';
import {
    AgencyIntegrationDescriptionBase,
    ClientIntegrationDescriptionBase,
    LocationIntegrationDescriptionBase,
} from './IntegrationDescriptionBase';
import { fromIntegrationLevelId } from './IntegrationLevel';

interface IntegrationIdDescriptionBase {
    platformId: PlatformId;
    integrationId: IntegrationId;
}

export interface AgencyIntegrationIdDescription
    extends IntegrationIdDescriptionBase,
        AgencyIntegrationDescriptionBase {}

export interface ClientIntegrationIdDescription
    extends IntegrationIdDescriptionBase,
        ClientIntegrationDescriptionBase {}
export interface LocationIntegrationIdDescription
    extends IntegrationIdDescriptionBase,
        LocationIntegrationDescriptionBase {}

export type IntegrationIdDescription =
    | AgencyIntegrationIdDescription
    | ClientIntegrationIdDescription
    | LocationIntegrationIdDescription;

export function fromIntegrationId(integrationId: IntegrationId): IntegrationIdDescription {
    const [id, integrationLevelId, platformId] = IntegrationId.explode(integrationId);

    const integrationLevel = fromIntegrationLevelId(integrationLevelId);

    switch (integrationLevel) {
        case 'agency':
            return {
                id: AgencyId.from(id),
                integrationId,
                level: integrationLevel,
                platformId,
            };
        case 'client':
            return {
                id: ClientId.from(id),
                integrationId,
                level: integrationLevel,
                platformId,
            };
        case 'location':
            return {
                id: LocationId.from(id),
                integrationId,
                level: integrationLevel,
                platformId,
            };
        default:
            return assertNever(integrationLevel);
    }
}

export function getLocationIdFromIntegrationId(integrationId: IntegrationId): LocationId {
    const descriptor = fromIntegrationId(integrationId);

    if (descriptor.level !== 'location') {
        throw new Error(`Integration ID ${integrationId} does not contain a Location ID`);
    }

    return descriptor.id;
}
